import React, {Component} from 'react';
import {IonBadge, IonContent, IonFab, IonFabButton, IonIcon, IonItem, IonLabel, IonList, IonText} from '@ionic/react';
import "../ContestDetailPage.css"
import Contest from "../../domain/Contest";
import {History} from "history";
import DateUtils from "../../utils/Date.utils";

type Props = {
  history: History;
  contest: Contest;
};

type State = {}

export default class ContestDetailInfoTab extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {};
  }

  render() {
    return (
      <>
        <IonContent>
          <div className="contest-detail-info-tab">
            <div className={"banner " + this.getBannerImageClass()}>
            </div>
            <IonList>
              {this.renderDatePart()}
              {this.renderLocationPart()}
              {this.renderClubPart()}
              {this.renderContactPersonPart("Hoofdverantwoordelijke", this.props.contest.localResponsible)}
              {this.renderContactPersonPart("Hoofdjury", this.props.contest.mainJury)}
              {this.renderMedicalPersonPart("Hoefsmid", this.props.contest.farrier)}
              {this.renderMedicalPersonPart("EHBO", this.props.contest.firstAid)}
              {this.renderMedicalPersonPart("Dierenarts", this.props.contest.veterinarian)}
              {this.renderInfo("Opmerkingen", this.props.contest.remarks)}
            </IonList>
          </div>
        </IonContent>
        <IonFab class={"contest-detail-info-tab floating-action-button"}
                vertical="bottom"
                horizontal="end" edge
                slot="fixed"
                onClick={() => this.props.history.push(`/contests/${this.props.contest.id}/series`)}>
          <IonFabButton class={"btn"} color="primary">
            <IonIcon name="list"/>
          </IonFabButton>
        </IonFab>
      </>
    );
  }

  private getBannerImageClass() {
    if (this.props.contest.categories.filter(c => c.toLowerCase() === "tornooi").length > 0) {
      return "banner-tornooi";
    } else if (this.props.contest.categories.filter(c => c.toLowerCase() === "dressuur").length > 0) {
      return "banner-dressage";
    } else if (this.props.contest.categories.filter(c => c.toLowerCase() === "springen").length > 0) {
      return "banner-jumping";
    } else if (this.props.contest.categories.filter(c => c.toLowerCase() === "veelzijdigheid").length > 0) {
      return "banner-eventing";
    } else if (this.props.contest.categories.filter(c => c.toLowerCase() === "jonge paarden ").length > 0) {
      return "banner-young-horse";
    }
    return "banner-tornooi";
  }

  renderDatePart() {
    return (
      <>
        <IonItem>
          <IonBadge class="contest-date item-badge" slot="start">
            <h2>{DateUtils.getDayOfMonth(DateUtils.fromStringToDate(this.props.contest.date)!)}</h2>
            <p>{DateUtils.getMonthAsString(DateUtils.fromStringToDate(this.props.contest.date)!)}</p>
          </IonBadge>
          <IonLabel class="item-label">
            <h1>{this.props.contest.title}</h1>
            <small>
              {this.renderCategories()}
            </small>
          </IonLabel>
        </IonItem>
      </>
    )
  }

  renderCategories() {
    return this.props.contest.categories.map((c: string, i: number) => {
      return (
        <IonBadge key={i} class="item-content-badge">{c}</IonBadge>
      );
    });
  }

  renderLocationPart() {
    if ("adres niet gekend" === this.props.contest.address) {
      return null;
    }
    return (
      <IonItem key={"location-part"} onClick={() => this.props.history.push(`/contests/${this.props.contest.id}/map`)}>
        <IonIcon name="pin" slot="start" class="item-badge">&nbsp;</IonIcon>
        <IonText class="item-label">
          <p>
            {this.props.contest.address}
          </p>
        </IonText>
        <IonIcon name="navigate" slot="end" class="item-badge">&nbsp;</IonIcon>
      </IonItem>
    )
  }

  renderClubPart() {
    return (
      <IonItem key={"club-part"}>
        <IonIcon name="aperture" slot="start" class="item-badge">&nbsp;</IonIcon>
        <IonText class="item-label">
          <p>{this.props.contest.clubName}</p>
        </IonText>
      </IonItem>
    )
  }

  renderContactPersonPart(key: string, name: string) {
    if ("niet gekend" === name) {
      return null;
    }
    return (
      <IonItem key={key}>
        <IonIcon name="man" slot="start" class="item-badge">&nbsp;</IonIcon>
        <IonText class="item-label">
          <p>{key}</p>
          <p>
            {name}
          </p>
        </IonText>
      </IonItem>
    )
  }

  renderMedicalPersonPart(key: string, name: string) {
    if ("niet gekend" === name) {
      return null;
    }
    return (
      <IonItem key={key}>
        <IonIcon name="medkit" slot="start" class="item-badge">&nbsp;</IonIcon>
        <IonText class="item-label">
          <p>{key}</p>
          <p>
            {name}
          </p>
        </IonText>
      </IonItem>
    )
  }

  renderInfo(key: string, name: string) {
    if ("niet gekend" === name) {
      return null;
    }
    return (
      <IonItem key={key}>
        <IonIcon name="information-circle" slot="start" class="item-badge">&nbsp;</IonIcon>
        <IonText class="item-label">
          <p>{key}</p>
          <p>
            {name}
          </p>
        </IonText>
      </IonItem>
    )
  }
}
